<template>
  <div class="animated revealUp">
    
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div
        class="section-title mb-3"
      >{{ $t('edit') }} {{ $tc('rawmaterials', 1) }} {{ $tc('category',1) }}</div>
      <router-link
        class="btn-blue"
        to="/fnb/raw-materials-categories"
      >{{ $tc('rawmaterials', 1) }} {{ $tc('category',1) }} {{ $tc('list', 2) }}</router-link>
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="rmc_category"
                name="rawmaterialcategory"
                id="rawmaterialcategory"
                v-validate="'required'"
              />
              <label>{{ $tc('rawmaterials', 1) }} {{ $tc('category',1) }}</label>
            </div>
            <Tooltip :title="$t('rawmaterial_tooltip')" />
          </div>
          <p class="error_message">
            <span
              v-if="submitted && errors.has('rawmaterialcategory')"
            >{{ errors.first('rawmaterialcategory') }}</span>
          </p>
        </div>

        <div class="col-md-4 mb-4">
          <div class="d-flex align-items-center">
            <label>{{ $t('active') }}</label>
            <label class="ios-switch ml-2">
              <input v-model="rmc_is_active" type="checkbox" class="ios-checkbox" checked />
              <span class="switch-slider"></span>
            </label>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button @click.prevent.stop="onFinalSubmit(false)" class="btn-blue">{{ $t('update') }}</button>
          <button @click.prevent.stop="onResetForm()" class="btn-black">{{ $t('reset') }}</button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="/fnb/raw-materials-categories"
          >{{ $t('cancel') }}</b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import MasterService from "@/services/MasterService";
import PosFnbService from "@/services/PosFnbService";
export default {
  components: { Multiselect },
  data() {
    return {
      submitted: false,
      rmc_category: "",
      rmc_is_active: true,
      rmc_id: "",
      BaseURL: ""
    };
  },
  beforeMount() {
    this.rmc_id = this.$route.query.rmc_id;
  },
  mounted() {
    this.getRawMaterialCategories();
  },
  methods: {
    getRawMaterialCategories: function() {
      let payload = {
        tableName: "ms_raw_material_category"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.ms_raw_material_category = data.Records;
            this.ms_raw_material_category.map(x => {
              if (this.rmc_id == x.rmc_id) {
                this.rmc_category = x.rmc_category;
                this.rmc_is_active = x.rmc_is_active == true ? "Y" : "N";
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    onResetForm: function() {
      (this.rmc_category = ""), (this.rmc_is_active = true);
    },
    onFinalSubmit(flag) {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        console.log("valid :", valid);
        if (valid) {
          let payload = {
            rmc_category: this.rmc_category,
            rmc_is_active: this.rmc_is_active,
            rmc_id: this.rmc_id
          };
          PosFnbService.UpdateRawMaterialCategory(payload)
            .then(response => {
              const { data } = response;
              if (data && data.status) {
                this.onResetForm();
                this.$router.push({
                  path: "raw-materials-categories"
                });
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError); //message
        }
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/RawMaterialCategoriesComponents/editRawMaterialCategories.vue